export default __webpack_public_path__ + "static/media/fiserv-logo.7e622f8f.svg";